<template>
  <svg viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg">
    <g clip-path="url(#a)">
      <path
        fill="currentColor"
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M6.37.852a7.326 7.326 0 0 1 8.37 4.258 7.333 7.333 0 0 1-1.168 7.655h.656a.733.733 0 0 1 0 1.466h-2.581a.733.733 0 0 1-.733-.732v-2.566a.733.733 0 1 1 1.466 0v.97A5.864 5.864 0 0 0 6.697 2.28.733.733 0 1 1 6.37.85ZM1.038 2.514c0-.405.328-.733.733-.733h2.564c.405 0 .733.328.733.733v2.554a.733.733 0 1 1-1.465 0v-.95a5.865 5.865 0 0 0 5.699 9.602.733.733 0 1 1 .326 1.43 7.326 7.326 0 0 1-8.364-4.248 7.333 7.333 0 0 1 1.154-7.655h-.647a.733.733 0 0 1-.733-.733Z"
      />
    </g>
    <defs>
      <clipPath id="a">
        <path d="M0 0h16v16H0z" fill="currentColor" />
      </clipPath>
    </defs>
  </svg>
</template>
